import { Head, Layout, Title, ProtectedPage } from '@/components'
import clsx from 'clsx'
import { Tab } from '@headlessui/react'

import { CreditCardIcon, HeartIcon, UserCircleIcon, ChatIcon } from '@heroicons/react/outline'
import { Fragment, useEffect, useState } from 'react'

import { Favourites, Profile, Reviews, Comments } from '@/components/Account'
import { useRouter } from 'next/router'
import { useQuery } from '@apollo/client'
import { ACTIVE_USER } from '@/queries'

const navigation = [
  { name: 'Profile', href: '#', icon: UserCircleIcon, current: true },
  { name: 'Reviews', href: '#', icon: CreditCardIcon, current: false },
  { name: 'Favourites', href: '#', icon: HeartIcon, current: false },
  // { name: 'Rentals', href: '#', icon: OfficeBuildingIcon, current: false },
  { name: 'Comments', href: '#', icon: ChatIcon, current: false },
]

export default function Account() {
  const { asPath } = useRouter()
  const [selectedIndex, setSelectedIndex] = useState(0)

  const { data } = useQuery(ACTIVE_USER)

  useEffect(() => {
    const path = asPath.split('#')
    if (path[1] === 'favourites') {
      setSelectedIndex(2)
    } else {
      setSelectedIndex(0)
    }
  }, [asPath])

  return (
    <ProtectedPage>
      <Layout className="lg:min-h-[50vh] pb-16 ">
        <Head title="Account" description="User Account" />
        <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
          <header className="px-6 pt-16 border-b dark:border-zinc-800 border-zinc-200 max-w-7xl mx-auto">
            <Title as="h1" size="2xl">
              Account
            </Title>
            <Tab.List className="flex mt-6">
              <nav className="flex flex-1">
                {navigation.map((item) => (
                  <Tab as={Fragment} key={item.name}>
                    {({ selected }) => (
                      <button
                        type="button"
                        className={clsx(
                          selected
                            ? 'text-brand-500 dark:text-zinc-50 border-brand-500'
                            : 'dark:text-zinc-400 hover:dark:text-zinc-50 text-zinc-600 hover:text-brand-600 hover:bg-zinc-200 hover:bg-opacity-50 hover:dark:bg-zinc-800 border-transparent hover:border-brand',
                          'group  px-6 py-4 flex items-center text-sm font-semibold justify-center relative border-b-2  focus:outline-brand ',
                        )}
                      >
                        <item.icon
                          className={clsx(
                            selected
                              ? 'dark:text-brand-500 text-brand-500'
                              : 'dark:text-brand-400 text-brand-400 group-hover:text-brand-500 dark:group-hover:text-brand-300',
                            'flex-shrink-0 sm:-ml-1 sm:mr-3 h-6 w-6',
                          )}
                        />
                        <span className="truncate sr-only sm:not-sr-only">{item.name}</span>
                      </button>
                    )}
                  </Tab>
                ))}
              </nav>
            </Tab.List>
          </header>

          <Tab.Panels className="space-y-6 sm:px-6 lg:px-0 lg:col-span-9 max-w-7xl mx-auto">
            <Tab.Panel className="focus:outline-none focus:ring-0">
              <Profile data={data?.activeUser} />
            </Tab.Panel>
            <Tab.Panel className="focus:outline-none focus:ring-0">
              <Reviews reviews={data?.activeUser.reviews} />
            </Tab.Panel>
            <Tab.Panel className="focus:outline-none focus:ring-0">
              <Favourites />
            </Tab.Panel>
            {/* <Tab.Panel className="focus:outline-none focus:ring-0">
              <Rentals rentals={data?.activeUser.rentals} />
            </Tab.Panel> */}
            <Tab.Panel className="focus:outline-none focus:ring-0">
              <Comments comments={data?.activeUser.comments} />
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </Layout>
    </ProtectedPage>
  )
}
